function createShareRequestId() {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }
  return `share-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

function buildSocialPostShareUrl(postId) {
  if (typeof window === 'undefined') {
    return `/social/posts/${postId}`;
  }
  return `${window.location.origin}/social/posts/${postId}`;
}

async function copySocialPostLink(postId) {
  const url = buildSocialPostShareUrl(postId);
  if (typeof navigator !== 'undefined' && navigator.clipboard?.writeText) {
    await navigator.clipboard.writeText(url);
    return { method: 'copy', url };
  }
  throw new Error('Clipboard unavailable');
}

/**
 * Explicit user-initiated SocialPost share.
 * Returns { shared: true, method } only after Web Share success or copy-link success.
 * Cancelled/rejected Web Share does not count as share.
 */
export async function shareSocialPost(postId, { shareApi, title, text } = {}) {
  if (!postId || !shareApi) {
    throw new Error('Invalid share request');
  }
  const url = buildSocialPostShareUrl(postId);
  if (typeof navigator !== 'undefined' && typeof navigator.share === 'function') {
    try {
      await navigator.share({ title: title || 'Travel story', text: text || '', url });
      const result = await shareApi(postId, createShareRequestId());
      return { shared: Boolean(result?.changed), method: 'web-share', apiResult: result };
    } catch (error) {
      if (error?.name === 'AbortError') {
        return { shared: false, method: 'web-share-cancelled' };
      }
      throw error;
    }
  }
  await copySocialPostLink(postId);
  const result = await shareApi(postId, createShareRequestId());
  return { shared: Boolean(result?.changed), method: 'copy-link', apiResult: result };
}

export { buildSocialPostShareUrl, copySocialPostLink, createShareRequestId };
